import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Alert,
    Label,

} from "reactstrap"
import Select from "react-select";
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";
import Shimmer from "react-shimmer-effect";
import CustomSelect from '../../../../helpers/ui/CustomSelect'

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import CreateBloc from '../Create/Blocs/CreateBloc'
import DatePicker from '../../../../helpers/ui/DatePicker'
import moment from 'moment'
import EditBloc from '../CreateAdmin/Blocs/CreateBloc';



export const createMonthOptions = () => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  return months.map((month, index) => {
    const value = index + 1;
    return {
      label: month,
      value: value,
      isDisabled: false, // default false
    };
  });
};

export const createYearOptions = (startYear = 2000) => {
  const currentYear = new Date().getFullYear();

  return Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => {
      const year = startYear + index;
      return {
        label: year,
        value: year,
      };
    }
  );
};

class IndexView extends Component {

    updateBloc = new UpdateBloc();
    createBloc = new CreateBloc();
    editBloc = new EditBloc()

    queryParams = new URLSearchParams(window.location.search)
    userdata = JSON.parse(localStorage.getItem('userdata'))
    position_uuid = this.userdata.employee_current_position_uuid

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            document: null,
            failedInfo: "Gagal Terjadi Kesalahan",
            creditType : 1,
            start_month  : moment().format("M"),
            end_month  : moment().format("M"),
            yearOptions : createYearOptions(),
            monthOptions : createMonthOptions(),
            monthOptionsStart: createMonthOptions(),
                  monthOptionsEnd: createMonthOptions(),
            typeOptions : [
              { value: 1, label: "Periode(Tahunan)" },
              {
                value: 2,
                label: "Periodik",
              },
            ]

        }
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm,  ["file_skp", "file_pak"])
        await this.updateBloc.fetchUpdate(dataForm)
        // await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values,
                credit_number_year: this.state.year
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()

                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            document_skp: response.document_skp,
                            document_pak: response.document_pak,
                            creditType : response.credit_number_type,
                            start_month : response.credit_number_start_month,
                            end_month : response.credit_number_end_month,
                            year : response.credit_number_year,
                            
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        // const queryParams = new URLSearchParams(this.props.location.search)
        // this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })
        const search = this.props.location?.search || window.location.search;

        if (!search) return;

        const params = new URLSearchParams(search);
        const uuid = params.get("uuid");

        if (uuid) {
            this.updateBloc.fetchDetail({ uuid });
        }

        this.editBloc.fetchcheckMonthChannel.subscribe((result) => {
            switch (result.status) {
            case apiResponse.LOADING:
                this.setState({
                loadingcheck: true,
                });
                break;
                
            case apiResponse.COMPLETED:
                if (result.data.status) {
                const response = result.data.response;
                
                // Cek bulan awal berdasarkan tahun yang dipilih untuk tipe 2
                const currentYear = Number(this.state.year);
                const usedMonthsData = response.filter(
                    item => item.credit_number_type === 2 && 
                            Number(item.credit_number_year) === currentYear
                );
                
                const usedStartMonths = usedMonthsData.map(item => 
                    Number(item.credit_number_start_month)
                );
                
                const monthOptionsStart = createMonthOptions().map(month => ({
                    ...month,
                    isDisabled: usedStartMonths.includes(month.value)
                }));
                
                const monthOptionsEnd = createMonthOptions();
                
                this.setState({
                    monthOptionsStart: monthOptionsStart,
                    monthOptionsEnd: monthOptionsEnd,
                    allCreditData: response,
                    loadingcheck: false
                });
                }
                break;
                
            case apiResponse.ERROR:
                this.setState({
                loadingcheck: false,
                });
                break;
                
            default:
                break;
            }
        });

        const storedUserdata = JSON.parse(localStorage.getItem("userdata"));
        const storedEmployeeSelected = JSON.parse(
        localStorage.getItem("employeeSelected")
        );
        const currentRole = localStorage.getItem("currentRoleName");
        let user_uuid = null;
        if (currentRole === "Administrator") {
        user_uuid = storedEmployeeSelected?.employee_uuid;
        } else {
        user_uuid = storedUserdata?.employee_uuid;
        }
        this.editBloc.fetchcheckMonth({employee_uuid : user_uuid})

    }

    componentWillUnmount(){
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                        <Card>
                            <CardBody>
                            <CardTitle>Ubah Riwayat Angka Kredit</CardTitle>
                            <CardSubtitle className="mb-3">
                                Setiap isian yang bertanda (
                                <span className="text-danger">*</span>) adalah wajib diisi.
                            </CardSubtitle>
                            <hr />
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) =>
                                this.handlerOnSubmit(e, values)
                                }
                            >

                            <AvField
                                type="hidden"
                                name="credit_number_position_uuid"
                                value={this.position_uuid}
                                className="form-control"
                            />
                            <AvField
                                name="credit_number_uuid"
                                type="hidden"
                                value={this.state.detail?.credit_number_uuid}
                            />

                            <Row className="mb-3">
                                <Label className="col-md-3 col-form-label">
                                Tipe Angka Kredit <span className="text-danger">*</span>
                                </Label>
                                <Col md="5">
                                {
                                    this.state.detail ?
                                        <>
                                        <CustomSelect
                                            name="credit_number_type"
                                            errorMessage="Pilih Tipe Angka Kredit"
                                            options={this.state.typeOptions}
                                            placeholder="Pilih Tipe Angka Kredit"
                                            defaultValue={this.state.detail?.credit_number_type}
                                            onChange={(v) => {
                                                this.setState({ creditType: v.value });
                                            }}
                                            isAvForm={false}
                                        />
                                        < AvField
                                            type="hidden"
                                            name="credit_number_type"
                                            value={this.state.creditType}
                                            className="form-control"/>
                                         
                                        </>
                                    : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                }
                                </Col>
                            </Row>

                            {this.state.creditType == 1 && (
                            <>
                                <Row className="mb-3">
                                    <label htmlFor="name" className="col-md-3 col-form-label">
                                        Tahun {" "}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <Col md="5">
                                    {
                                    this.state.detail ?
                                        <>
                                            <CustomSelect
                                                name="credit_number_year"
                                                errorMessage="Pilih Tahun"
                                                options={this.state.yearOptions}
                                                placeholder="Pilih Tahun"
                                                defaultValue={this.state.year}
                                                onChange={(v) => {
                                                    this.setState({ year: v.value });
                                                }}
                                                isAvForm={false}
                                                />

                                            <AvField
                                                type="hidden"
                                                name="credit_number_year"
                                                value={this.state.year }
                                                className="form-control"/>
                                        </>
                                        
                                        : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                    }
                                    </Col>
                                </Row>
                            </>
                            ) }


                            {this.state.creditType == 2 && (
                            <>
                                 <Row className="mb-3">
                                    <label htmlFor="name" className="col-md-3 col-form-label">
                                        Tahun {" "}
                                        <span className="text-danger">*</span>
                                    </label>
                                    <Col md="5">
                                    {
                                    this.state.detail ?
                                        <>
                                            <CustomSelect
                                                name="credit_number_year"
                                                errorMessage="Pilih Tahun"
                                                options={this.state.yearOptions}
                                                placeholder="Pilih Tahun"
                                                defaultValue={this.state.year}
                                                onChange={(v) => {
                                                this.setState({ year: v.value }, () => {
                                                    const response = this.state.allCreditData || [];
                                                    const selectedYear = Number(v.value);
                                                    
                                                    const usedMonthsData = response.filter(
                                                    item => item.credit_number_type === 2 && 
                                                            Number(item.credit_number_year) === selectedYear
                                                    );
                                                    
                                                    const usedStartMonths = usedMonthsData.map(item => 
                                                    Number(item.credit_number_start_month)
                                                    );
                                                    
                                                    const monthOptionsStart = createMonthOptions().map(month => ({
                                                    ...month,
                                                    isDisabled: usedStartMonths.includes(month.value)
                                                    }));
                                                    
                                                    this.setState({ monthOptionsStart });
                                                });
                                                }}
                                                isAvForm={false}
                                                />

                                            <AvField
                                                type="hidden"
                                                name="credit_number_year"
                                                value={this.state.year }
                                                className="form-control"/>
                                        </>
                                        
                                        : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                    }
                                    </Col>
                                </Row>
                                
                                <Row className="mb-3">
                                    <label htmlFor="name" className="col-md-3 col-form-label">
                                    Bulan Awal{" "}
                                    <span className="text-danger">*</span>
                                    </label>
                                    <Col md="5">
                                        {
                                        this.state.detail ?
                                            <>
                                                <CustomSelect
                                                    name="credit_number_start_month"
                                                    errorMessage="Pilih Bulan Awal"
                                                    options={this.state.monthOptionsStart}
                                                    placeholder="Pilih Bulan Awal"
                                                    defaultValue={this.state.start_month}
                                                    onChange={(v) => {
                                                    this.setState({ start_month: v.value });
                                                    }}
                                                    isAvForm={false}
                                                />
                                                    <AvField
                                                    type="hidden"
                                                    name="credit_number_start_month"
                                                    value={this.state.start_month}
                                                    className="form-control"
                                                />
                                            </>
                                            : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                        }
                                    
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label htmlFor="name" className="col-md-3 col-form-label">
                                    Bulan Akhir{" "}
                                    <span className="text-danger">*</span>
                                    </label>
                                    <Col md="5">
                                        {
                                        this.state.detail ?
                                            <>
                                                <CustomSelect
                                                    name="credit_number_end_month"
                                                    errorMessage="Pilih Bulan Akhir"
                                                    options={this.state.monthOptionsEnd}
                                                    placeholder="Pilih Bulan Akhir"
                                                    defaultValue={this.state.end_month}
                                                    onChange={(v) => {
                                                    this.setState({ end_month: v.value });
                                                    }}
                                                    isAvForm={false}
                                                />
                                                    <AvField
                                                    type="hidden"
                                                    name="credit_number_end_month"
                                                    value={this.state.end_month}
                                                    className="form-control"
                                                />

                                            </>
                                            : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                        }
                                    
                                    </Col>
                                </Row>
                            </>
                            ) }
                                

                            <Row className="mb-3">
                                <label htmlFor="name" className="col-md-3 col-form-label">
                                    Angka Kredit{" "}
                                    <span className="text-danger">*</span>
                                </label>
                                <Col md="5">
                                    {
                                    this.state.detail ?
                                        <>
                                            <AvField
                                                name="credit_number_value"
                                                placeholder=" Angka Kredit..."
                                                type="number"
                                                errorMessage="Masukkan Angka Kredit"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="credit_number_value"
                                                onChange={this.handleTotalCreditChange}
                                                value={this.state.detail?.credit_number_value}
                                                />
                                        </>
                                        : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                    }
                                    
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label htmlFor="name" className="col-md-3 col-form-label">
                                    Unggah SKP <span className="text-danger">*</span>
                                </label>
                                <Col md="5">
                                    <FileInput
                                    name="file_skp"
                                    validate={{ required: { value: 
                                        this.state.document_skp !== null ? false : true
                                        } }}
                                    col="6"
                                    isMultiple={false}
                                    maxFiles={1}
                                    errorMessage="Harap pilih file SKP"
                                    />
                                </Col>
                                <Col md="2">
                                    {
                                        this.state.detail ?
                                            <>
                                                {this.state.document_skp !== null &&
                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document_skp?.documents_path}>
                                                        Download <i className="fa fa-download ms-1"></i>
                                                    </a>
                                                }
                                            </>
                                        :
                                            <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <label htmlFor="name" className="col-md-3 col-form-label">
                                    Unggah PAK 
                                    {this.state.creditType == 2 && (
                                    <span className="text-danger">*</span>
                                    )}
                                </label>
                                <Col md="5">
                                    <FileInput
                                    name="file_pak"
                                    validate={{ required: { value: 
                                        this.state.document_skp !== null ? false : 
                                        (this.state.creditType != 1 )
                                    } }}
                                    col="6"
                                    isMultiple={false}
                                    maxFiles={1}
                                    errorMessage="Harap pilih file PAK"
                                    />
                                </Col>
                                <Col md="2">
                                    {
                                        this.state.detail ?
                                            <>
                                                {this.state.document_pak !== null &&
                                                    <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document_pak?.documents_path}>
                                                        Download <i className="fa fa-download ms-1"></i>
                                                    </a>
                                                }
                                            </>
                                        :
                                            <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                    }
                                </Col>
                            </Row>

                                <Row className="mb-3">
                                <Col md="3"></Col>
                                <Col md="9">
                                    <Link to="/kepegawaian/pengajuan_angka_kredit.html">
                                    <Button color="danger">
                                        <i className="uil-arrow-left"></i> Kembali
                                    </Button>
                                    </Link>{" "}
                                    <Button color="success" type="submit">
                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                    </Button>
                                </Col>
                                </Row>
                            </AvForm>
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo={this.state.failedInfo}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/pengajuan_angka_kredit.html?'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView